import {isNil} from 'ramda';

import type {PurchasePriceRuleResponseBody} from '@dms/api/sales';

import {PurchasePriceRuleFormValues} from '../schemas/PurchasePriceRuleFormSchema';

export const toPurchasePriceRuleFormValues = (
  source: Pick<PurchasePriceRuleResponseBody, 'priceBands' | 'warrantyCost' | 'modifiers'>,
  identity: Pick<PurchasePriceRuleFormValues, 'name' | 'scope'>
) => ({
  ...identity,
  priceBands: source.priceBands.map((band) => ({
    upperBound: isNil(band.upperBoundInclusive) ? null : Number(band.upperBoundInclusive),
    marginType: band.margin.type,
    marginValue: Number(band.margin.value),
  })),
  warrantyCost: Number(source.warrantyCost),
  modifiers: {
    electricVehicle: {
      enabled: source.modifiers.electricVehicle.enabled,
      percentage: Number(source.modifiers.electricVehicle.percentage),
    },
    highMileage: {
      enabled: source.modifiers.highMileage.enabled,
      percentage: Number(source.modifiers.highMileage.percentage),
      threshold: source.modifiers.highMileage.threshold,
    },
    higherAge: {
      enabled: source.modifiers.higherAge.enabled,
      percentage: Number(source.modifiers.higherAge.percentage),
      threshold: source.modifiers.higherAge.threshold,
    },
  },
});
